import axios, {
  AxiosHeaders,
  type AxiosInstance,
  type AxiosRequestConfig,
  type InternalAxiosRequestConfig,
} from "axios";
import { getToken } from "@/services/auth/auth-utils";

function normalizeHeaders(headers: AxiosRequestConfig["headers"]): AxiosHeaders {
  if (headers instanceof AxiosHeaders) return headers;

  const resolved = new AxiosHeaders();
  if (!headers) return resolved;

  for (const [key, value] of Object.entries(headers as Record<string, unknown>)) {
    if (typeof value === "string" || typeof value === "number" || typeof value === "boolean") {
      resolved.set(key, String(value));
    }
  }
  return resolved;
}

function withAuthorizationHeader(headers: AxiosRequestConfig["headers"], token: string): AxiosHeaders {
  const resolved = normalizeHeaders(headers);
  resolved.set("Authorization", `Bearer ${token}`);
  resolved.set("Content-Type", "application/json");
  return resolved;
}

function createApiClient(baseURL: string): AxiosInstance {
  const client = axios.create({ baseURL, timeout: 30000 });

  client.interceptors.request.use((config: InternalAxiosRequestConfig) => {
    const token = getToken();
    if (token) {
      config.headers = withAuthorizationHeader(config.headers, token);
    }
    return config;
  });

  return client;
}

export const apiClient = createApiClient(window.APP_SETTINGS?.apiUrl ?? "/api");

export { createApiClient };
